import { MosaicTocSectionClass } from "./MosaicTocSectionClass";
import type { IMosaicTocExpanded } from "./interface";

/**
 * Marks changed ToC items as failed after a save error.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state after the save failure is recorded.
 */
export const toc_saveFail = (state: IMosaicTocExpanded): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };

  newState.blocked = false;
  newState.changed = true;
  newState.saveError = true;
  newState.saving = false;
  newState.sendUpdate = false;
  newState.tocItems
    .filter((item) => item.changed)
    .forEach((item) => {
      if (item instanceof MosaicTocSectionClass) {
        item.markSaveFailed();
      } else {
        item.inError = true;
        item.changed = true;
      }
    });

  return newState;
};
